import {
  Button,
  Box,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  makeStyles,
  Card,
  CardContent,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Tooltip,
  CardMedia,
} from "@material-ui/core";
import { FaUser, FaEdit, FaTrash } from 'react-icons/fa';
import Search from "@material-ui/icons/Search";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect, useSelector} from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import LabelWithInput from '../components/common/controls/LabelWithInput/LabelWithInput';
// import AddDynamicFields from "../components/common/controls/AddDynamicFields";
import AntSwitch from "../components/common/controls/AntSwitch";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import DMSelect from "../components/common/controls/DMSelect";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import { deleteModelService, sortMoelService, addNewMarketService,createNewSalesOfficeService,createNewRegionService,updateSalesOfficeService,updateRegionSalesMarketService } from "../services/ModelsService";
import { uuidv4 } from "../utilities/applicationutils";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";
import { width } from "@fortawesome/free-solid-svg-icons/faSave";
import { LineWeight } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import PersonIcon from '@material-ui/icons/Person'
import SaveIcon from '@material-ui/icons/Save';
import { useHistory } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';
import SvgIcon from "@material-ui/core/SvgIcon";
import { ReactComponent as CarrierOfficeIcon } from "../assets/images/carrier-office-icon.svg";
import { ReactComponent as DevelopedEconomyIcon } from "../assets/images/developed-economy-icon.svg";
var CONTROLS_DATA = require("./ControlsData.json");


const Models = ({
  modelState,
  miscState,
  deleteState,
  currencyState,
  createState,
  getModels,
  getRegionsT,
  deleteModel,
  createNewModel,
  updateModel,
  getRegions,
  onMoreOptionsSelected,
  onTabSelected,
  setSnackBar,
  onPageSelected,
  onCloseSelected,
  getSalesOffice,
  getMarket,
  addNewRegion,
  deleteAdminService,
  updateRegionSalesMarket,
  addNewMarket,
  getCurrency,
  createNewSalesOffice,
  onModelSelected,
  updateSalesOffice,
  breadCrumbSettingAction,
  breadCrumbInStore
}) => {
  const [models, setModels] = useState([]);
  //const [regionsT, setRegionsT] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewRegionModel, setShowNewRegionModel] = useState(false);
  const [showNewSalesOfficeModel, setShowNewSalesOfficeModel] = useState(false);
  const [showNewMarketModel, setShowNewMarketModel] = useState(false);
  const [newModel, setNewModel] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedModel, setSelectedModel] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);

  // State Management
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [editData, setEditData] = useState('');
  const [editingType, setEditingType] = useState('');
  const [editId,setEditId] = useState('');
  const onNewProjectClick = () => setShowNewRegionModel(true);
  const [userName, setUserName] = useState("");
  const [marketName, setMarketName] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [isCarrierOffice, setIsCarrierOffice] = useState(false);
  const [isDevelopedEconomy, setIsDevelopedEconomy] = useState(false);
  const [miscStateHandler, setMiscStateHandler] = useState();
  const [editOffice, setEditOffice] = useState(false);
  const [salesOfficeIdEdit, setSalesOfficeIdEdit] = useState(null);
  const [dataCurrencyVal, setDataCurrencyVal] = useState([]);

  const deleteStateHasError = useSelector((state) => state.model.deleteModel);

  const getRegionName = (model) => {
    const arr = [...modelState?.regions?.data];
    const region = arr.find((ele) => ele?.regionId === model?.regionId);
    return region?.regionName;
  };

  //Below 3 are card operations
  // Handle Edit Dialog Open
  const handleEditOpen = (data, type) => {
    setOpenDialog(true);
    if(type === "region"){
      setEditData(data.regionName);
      setEditId(data.regionId);
      setEditingType(type);
    }
    else{
      setEditData(data.marketName);
      setEditId(data.marketId);
      setEditingType(type);
    }
  };

  // Handle Edit Dialog Close
  const handleEditClose = () => {
      setOpenDialog(false);
  };

  // Handle Save after Edit
  const handleEditSave = async(type) => {
    console.log('type in editSave',type);
    if(type === "region"){
      const data = {
        "regionId":editId,
        "regionName":editData
      }
      setLoading(true);
      try{
        await updateRegionSalesMarketService(data,type).then((response) => {
          getRegionsT();
          setSnackBar(true,"success","updated successfully")
          setLoading(false);
          setOpenDialog(false);
        })
        .catch((error) => {
          setSnackBar(true,"error",error.response.data.errorMessage);
          setLoading(false);
          setOpenDialog(false);
        })
        // await updateRegionSalesMarket(data,type);
        // await getRegionsT();
        // setSnackBar(true,"success","updated successfully")
        // setLoading(false);
        // setOpenDialog(false);
      }
      catch(error) {
        setLoading(false);
        setOpenDialog(false);
        setSnackBar(true,"error","Not updated");
        console.log('error in updating the value',error);
      }
    }
    else if(type === "market"){
      const data = {
        "marketId":editId,
        "marketName":editData,
        "salesOfficeId":selectedOffice.salesOfficeId
      }
      setLoading(true);
      try{
        await updateRegionSalesMarketService(data,type).then((response) => {
          getMarket(selectedOffice)
          setSnackBar(true,"success","Market Updated Successfully");
          setLoading(false);
          setOpenDialog(false);
        })
        .catch((error) =>{
          setLoading(false);
          setOpenDialog(false);
          setSnackBar(true,"error",error.response.data.errorMessage);
        })
        // await updateRegionSalesMarket(data,type)
        // await getMarket(selectedOffice)
        // setSnackBar(true,"success","Market Updated Successfully");
        // setLoading(false);
        // setOpenDialog(false);
      }
      catch(error){
        setLoading(false);
        setOpenDialog(false);
        setSnackBar(true,"error","Market Not updated");
      }
    }
  };

  useEffect(() => {
    if (modelState?.models?.data?.length) {
      getRegions();
    }
  }, [modelState.models.data]);

  useEffect(() => {
    setIsDisabled(
      !(newModel && newModel?.region?.length > 0 && newModel?.model?.length > 0)
    );
  }, [newModel]);

  useEffect(() => {
    if (modelState.models.hasError) {
      setSnackBar(true, "error", "Error while retrieving Models");
    }
  }, [modelState.models.hasError]);


  //My Use Effect for triple screen
  useEffect(() =>{
    getRegionsT();
  },[]);


  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "45% 30% 15% 10%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);


  const isModelPresentInNew = (modelName, selectedModel, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.region == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const handleAddRegion = async() => {
    console.log('tesing username',userName);
    const data = {
      "regionName":userName.charAt(0).toUpperCase() + userName.slice(1)
    }
    if(userName){
    setLoading(true);
    try{
      await createNewRegionService(data).then((response) => {
        console.log('region add success',response);
        getRegionsT();
        setSnackBar(true,"success","Region add successfully");
        setShowNewRegionModel(false);
        setUserName('');
        setLoading(false);
      })
      .catch((error) => {
        setSnackBar(true,"error",error.response.data.errorMessage);
        setShowNewRegionModel(false);
        setUserName('');
        setLoading(false);
      })
      // await addNewRegion(data);
      // await getRegionsT();
      // setSnackBar(true,"success","Region add successfully");
      // setShowNewRegionModel(false);
      // setUserName('');
      // setLoading(false);
    }
    catch(error){
      console.log('error while creating and fetching the region',error);
      setSnackBar(true,"error","Region Not Added SuccessFully");
      setLoading(false);
    }
  } else {
    setSnackBar(true,"error","Please enter region name!");
    setLoading(false);
  }
  }

  const handleAddMarket = async() => {
    if(selectedOffice?.salesOfficeId){
    const data = {
      "salesOfficeId":selectedOffice.salesOfficeId,
      "marketName": marketName.charAt(0).toUpperCase() + marketName.slice(1)
    }
    if(marketName){
    setLoading(true);
    try{
      await addNewMarketService(data).then((response) => {
        console.log('success in add market',response);
        getMarket(selectedOffice);
        setSnackBar(true,"success","Market add successfully");
        setMarketName('');
        setShowNewMarketModel(false);
        setLoading(false);
      })
      .catch((error) => {
        console.log('error in add',error.response.data.errorMessage);
        setSnackBar(true,"error", error.response.data.errorMessage);
        setMarketName('');
        setShowNewMarketModel(false);
        setLoading(false);
      })
      //await addNewMarket(data);
      // if(!createState?.hasError){
      //   await getMarket(selectedOffice);
      //   setSnackBar(true,"success","Market add successfully");
      //   setMarketName('');
      //   setShowNewMarketModel(false);
      //   setLoading(false);
      // }
      // else{
      //   setSnackBar(false,"error","Market Not added !!");
      //   setMarketName('');
      //   setShowNewMarketModel(false);
      //   setLoading(false);
      // }

    }
    catch(error){
      console.log('error while creating and fetching the region',error);
      setSnackBar(true,"error","Market Not Added SuccessFully");
      setLoading(false);
    }
  }
  else {
    setSnackBar(true,"error","Please enter market name!");
    setLoading(false);
  }
}else{
    setSnackBar(true,"error","Please select a sales office to add market !!")
}
  }
  const deleteConfirmRegion = async(event,data,type) => {
    event.stopPropagation();
    setLoading(true);
    if(type === "region"){
      try{
        //await deleteAdminService(data.regionId,type)
        await deleteModelService(data.regionId,type).then((response) => {
          console.log('response',response);
          const data = response.status;
          getRegionsT();
          setSnackBar(true,"success","Deleted successfully");
          setLoading(false);
        })
        .catch((error) =>{
          console.log('errror', error.response);
          setSnackBar(true,"error", error?.response?.data?.errorMessage);
          setLoading(false);
        })
        // setTimeout(async() => {
        //   console.log('testing hasError',deleteStateHasError);
        //   if(!deleteState.hasError){
        //     await getRegionsT();
        //     setSnackBar(true,"success","Deleted successfully");
        //   }
        //   else{
        //     setSnackBar(true,"error", deleteState.data.error);
        //   }
        //   setLoading(false);
        // },1000)
      }
      catch(error){
        setSnackBar(true,"error", "Region not deleted !!");
        setLoading(false);
      }
    }
    else if(type === "market"){
      try{
        // await deleteAdminService(data.marketId,type)
        // if(!deleteState.hasError){
        //   await getMarket(selectedOffice);
        // }
        // setSnackBar(true,"success","market deleted successfully");
        // setLoading(false);
        await deleteModelService(data.marketId,type).then((response) => {
          const data = response.status;
          getMarket(selectedOffice);
          setSnackBar(true,"success","Deleted successfully");
          setLoading(false);
        })
        .catch((error) =>{
          setSnackBar(true,"error", error.response.data.errorMessage);
          setLoading(false);
        })
      }
      catch(error){
        setSnackBar(true,"error", "Market not deleted !!");
        setLoading(false);
      }
    }
    else if(type === "office"){
      try{
        // await deleteAdminService(data.salesOfficeId,type)
        // if(!deleteState.hasError){
        //   await getSalesOffice(selectedRegion);
        // }
        // setSnackBar(true,"success","Sales Office deleted successfully");
        // setLoading(false);
        await deleteModelService(data.salesOfficeId,type).then((response) => {
          const data = response.status;
          getSalesOffice(selectedRegion);
          setSnackBar(true,"success","Sales Office deleted successfully");
          setLoading(false);
        })
        .catch((error) =>{
          setSnackBar(true,"error", error.response.data.errorMessage);
          setLoading(false);
        })
      }
      catch(error){
        console.log('error while creating and fetching the region',error);
        setSnackBar(true,"error", "Sales Office not deleted !!");
        setLoading(false);
      }
    }
  }

  const handleAddNewSalesOffice = async() => {
    setShowNewSalesOfficeModel(true);
    setLoading(true);
    await getCurrency()
    if(!currencyState?.currency?.isLoading){
      setLoading(false);
    }
  } 

  const handleEditOffice = async(officeDetails) => {
    setShowNewSalesOfficeModel(true);
    setLoading(true);
    await getCurrency();
    setUserName(officeDetails.salesOfficeName);
    setSelectedCurrency(officeDetails.currencyId);
    setIsCarrierOffice(officeDetails.isCarrier);
    setIsDevelopedEconomy(officeDetails.isDevelopedEconomy);
    setSalesOfficeIdEdit(officeDetails.salesOfficeId);
    setEditOffice(true);
    if(!currencyState?.currency?.isLoading){
      setLoading(false);
    }
  }

  const handleCreateSalesOffice = async() => {
    if(!editOffice){
      if(selectedRegion?.regionId){
        setLoading(true);
        const data = {
          "regionId":selectedRegion?.regionId,
          "isCarrier":isCarrierOffice,
          "isDevelopedEconomy":isDevelopedEconomy,
          "salesOfficeName":userName.charAt(0).toUpperCase() + userName.slice(1),
          "currencyId":selectedCurrency
        }
        if(userName){
        try{
          await createNewSalesOfficeService(data).then((response) => {
            console.log('success in create sales office',response);
            getSalesOffice(selectedRegion)
            setSnackBar(true,"success","Sales Office add successfully");
            setShowNewSalesOfficeModel(false);
            setUserName('');
            setSelectedCurrency('');
            setIsCarrierOffice(false);
            setIsDevelopedEconomy(false);
            setLoading(false);
          })
          .catch((error) =>{
            console.log("error in creat sales office",error.response.data.errorMessage);
            setSnackBar(true,"Error",error.response.data.errorMessage);
            setShowNewSalesOfficeModel(false);
            setUserName('');
            setSelectedCurrency('');
            setIsCarrierOffice(false);
            setIsDevelopedEconomy(false);
            setLoading(false);
          })
          // await createNewSalesOffice(data)
          // if(!createState.hasError){
          //   await getSalesOffice(selectedRegion)
          // }
          // setSnackBar(true,"success","Sales Office add successfully");
          // setShowNewSalesOfficeModel(false);
          // setUserName('');
          // setSelectedCurrency('');
          // setIsCarrierOffice(false);
          // setIsDevelopedEconomy(false);
          // setLoading(false);
        }
        catch(error) {
          console.log('create sales office error',error);
          setSnackBar(true,"Error","sales office did not added");
          setShowNewSalesOfficeModel(false);
          setLoading(false);
        }
      }
      else{
        setSnackBar(true,"Error","Please enter sales office name!");
        setLoading(false);
      }
      }
      else{
        setSnackBar(true,"Error","Please select a region to add sales office !!")
      }
    }
    else{
      if(selectedRegion?.regionId){
        setLoading(true);
        const data = {
          "regionId":selectedRegion?.regionId,
          "salesOfficeId":salesOfficeIdEdit,
          "isCarrier":isCarrierOffice,
          "isDevelopedEconomy":isDevelopedEconomy,
          "salesOfficeName":userName.charAt(0).toUpperCase() + userName.slice(1),
          "currencyId":selectedCurrency
        }
        try{
          await updateSalesOfficeService(data).then((response) =>{
            getSalesOffice(selectedRegion);
            setSnackBar(true,"success","Sales Office updated successfully");
            setShowNewSalesOfficeModel(false);
            setUserName('');
            setSelectedCurrency('');
            setIsCarrierOffice(false);
            setIsDevelopedEconomy(false);
            setLoading(false);
            setEditOffice(false);
          })
          .catch((error) => {
            setSnackBar(true,"Error","sales office record did not updated");
            setShowNewSalesOfficeModel(false);
            setUserName('');
            setSelectedCurrency('');
            setIsCarrierOffice(false);
            setIsDevelopedEconomy(false);
            setLoading(false);
            setEditOffice(false);
          })
          // await updateSalesOffice(data);
          // if(!updateModel.hasError){
          //   await getSalesOffice(selectedRegion)
          // }
          // setSnackBar(true,"success","Sales Office updated successfully");
          // setShowNewSalesOfficeModel(false);
          // setUserName('');
          // setSelectedCurrency('');
          // setIsCarrierOffice(false);
          // setIsDevelopedEconomy(false);
          // setLoading(false);
        }
        catch(error){
          console.log('create sales office error',error);
          setSnackBar(true,"Error","sales office record did not updated");
          setShowNewSalesOfficeModel(false);
          setLoading(false);
          setUserName('');
          setSelectedCurrency('');
          setIsCarrierOffice(false);
          setIsDevelopedEconomy(false);
          setEditOffice(false);
        }
      }
      else{
        setSnackBar(true,"Error","Please select a region to add sales office !!")
      }
    }
  }

  const handleRegionSelection = (region) => {
    setSelectedRegion(region); 
    setSelectedOffice(null); 
    setSelectedMarket(null);
    getCurrency();
    getSalesOffice(region);
  }
  const handleSalesOfficeSelection = (sales) => {
    setSelectedOffice(sales);
    setSelectedMarket(null);
    getMarket(sales);
  }

  useEffect(() => {
      setDataCurrencyVal([...currencyState?.data].sort((a, b) => a.currencyName.localeCompare(b.currencyName)));
  },[currencyState.data])
  const history = useHistory();
  const regionsT = useSelector((state) => state.model.tripleScreen.region ? state.model.tripleScreen.region : []);
  const salesOfficeData = useSelector((state) => state.model.tripleScreen.sales ? state.model.tripleScreen.sales : []);
  const marketOfficeData = useSelector((state) => state.model.tripleScreen.market ? state.model.tripleScreen.market : []);
  const handleNavigateUsers = async() => {
    await onTabSelected(1);
    console.log('testing misc state',miscState);
    history.push("/licenseManager/admin/users")
  }
  const navigateToRegionLevel = async (region) => {
    await onModelSelected("REGION");
    await breadCrumbSettingAction(`Admin > ${region.regionName}`)
    localStorage.setItem("regionIdValue",region.regionId);
    history.push(`/licenseManager/region/regionsLevel/${region.regionId}`);
  }
  // Clicking on go to sales office button will navigate to sales office level
  const navigateToSalesOfficeLevel = async (office) => {
    console.log('checking office',office);
    await onModelSelected("SALES_OFFICE");
    await breadCrumbSettingAction(`${breadCrumbInStore} > ${office.salesOfficeName}`)
    localStorage.setItem("salesOfficeValue",office.salesOfficeId);
    const currencyObject = currencyState&& currencyState?.data.find(currency => currency.currencyId === office.currencyId);
    localStorage.setItem("currencySymbolValue",currencyObject?.currencySymbol);
    history.push(`/licenseManager/office/customers/${office.salesOfficeId}`);
  }
  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={4} md={9} className="page-content card-content-region">
        {/* Region Card */}
        <div className="card-header-info">
          <Typography variant="h6" className="card-header-typograpy">Regions</Typography>
          <CustomButton
              id="newModel"
              showGradient={true}
              variant="contained"
              color="primary"
              disabled={false}
              name="Add Region"
              onClick={() => setShowNewRegionModel(true)}
            />
        </div>
        <Card style={{ minWidth: 275, width:'100%',backgroundColor:'#E5E7ED' }}>
          <CardContent>
            {/* <Typography variant="h6">Regions</Typography> */}
            {regionsT && regionsT.map((region) => (
              <div
                key={region.regionId}
                className="btn-cluster-grp"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '8px',
                  cursor: 'pointer',
                  gap: '8px',
                  borderRadius:'4px',
                  alignItems:"center",
                  marginBottom:"8px",
                  backgroundColor: selectedRegion?.id === region.id ? '#1891F6' : '#FFFFFF',
                }}
                onClick={() => 
                  handleRegionSelection(region)
                }
              >
                <Typography>{region.regionName}</Typography>
                <div className="grid-icon">
                  <button 
                  className="goto-button" 
                  style={{backgroundColor: selectedRegion?.id === region.id ? '#FFFFFF' : '#1891F6',color:selectedRegion?.id === region.id ? '#1891F6' : '#FFFFFF'}} onClick={() => navigateToRegionLevel(region)}>Go To Regions</button>
                  <div className="grid-action-item-icon-container">
                    <PersonOutlineOutlinedIcon onClick={()=>{handleNavigateUsers()}}/>
                  </div>
                  <div className="grid-action-item-icon-container" key={"right"}>
                    <EditIcon
                      className="grid-action-item-icon"
                      onClick={() => handleEditOpen(region, 'region')}
                    />
                  </div>
                  <div className="grid-action-item-icon-container">
                    <DeleteIcon
                      className="grid-action-item-icon"
                      onClick={(event) => deleteConfirmRegion(event,region,'region')}
                      //onClick={() => console.log(`Delete Region${region.regionName}`)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      </Grid>
      <Grid container xs={4} md={9} className="page-content card-content-sales">
        {/* Sales Office Card */}
        {/* {selectedRegion && ( */}
          <div className="card-header-info">
            <Typography variant="h6" className="card-header-typograpy">Sales Offices</Typography>
            <CustomButton
                id="newModel"
                showGradient={true}
                variant="contained"
                color="primary"
                disabled={false}
                name="Add Sales Office"
                onClick={handleAddNewSalesOffice}
              />
          </div>
          <Card style={{ minWidth: 275,width:'100%',backgroundColor:'#E5E7ED' }}>
            <CardContent>
              {salesOfficeData && salesOfficeData.map((office) => {
                const currencyObject = currencyState&& currencyState?.data.find(currency => currency.currencyId === office.currencyId);
                return (
                <div
                  key={office.salesOfficeId}
                  className="btn-cluster-grp"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '8px',
                    cursor: 'pointer',
                    gap: '8px',
                    borderRadius:'4px',
                    alignItems:"center",
                    marginBottom:"8px",
                    backgroundColor: selectedOffice?.salesOfficeId === office.salesOfficeId ? '#1891F6' : '#FFFFFF',
                  }}
                  onClick={() => 
                    handleSalesOfficeSelection(office)
                    // { 
                    // setSelectedOffice(office);
                    // setSelectedMarket(null);
                    // }
                  }
                >
                  <Typography>{office.salesOfficeName}</Typography>
                  <Tooltip id="button-carrier" placement="start-top" title={(office.isCarrier === true) ?"Carrier Office":""}><SvgIcon>{(office.isCarrier === true) ? <CarrierOfficeIcon/>: null}</SvgIcon></Tooltip>
                  <Tooltip id="button-developed" placement="start-top" title={(office.isDevelopedEconomy === true) ?"Developed Economy":""}><SvgIcon>{(office.isDevelopedEconomy === true) ? <DevelopedEconomyIcon/>: null}</SvgIcon></Tooltip>
                  <Typography>{currencyObject?currencyObject.currencySymbol: "N/A"}</Typography>
                  <div className="grid-icon">
                    <button 
                    className="goto-button" 
                    style={{backgroundColor: selectedOffice?.salesOfficeId === office.salesOfficeId ? '#FFFFFF' : '#1891F6',color:selectedOffice?.salesOfficeId === office.salesOfficeId ? '#1891F6' : '#FFFFFF'}} onClick={() => navigateToSalesOfficeLevel(office)}>Go To Sales Office</button>
                    <div className="grid-action-item-icon-container">
                      <PersonOutlineOutlinedIcon onClick={()=>{handleNavigateUsers()}}/>
                    </div>
                    <div className="grid-action-item-icon-container" key={"right"}>
                      <EditIcon
                        className="grid-action-item-icon"
                        onClick={() => handleEditOffice(office)}
                      />
                    </div>
                    <div className="grid-action-item-icon-container">
                      <DeleteIcon
                        className="grid-action-item-icon"
                        onClick={(event) => deleteConfirmRegion(event,office,'office')}
                      />
                    </div>
                  </div>
                </div>
              )})}
            </CardContent>
          </Card>
        {/* )} */}
      </Grid>
      <Grid container xs={4} md={9} className="page-content card-cotent-market">
        {/* Market Card */}
        {/* {selectedOffice && ( */}
          <div className="card-header-info">
              <Typography variant="h6" className="card-header-typograpy">Markets</Typography>
              <CustomButton
                  id="newModel"
                  showGradient={true}
                  variant="contained"
                  color="primary"
                  disabled={false}
                  name="Add Market"
                  onClick={() => setShowNewMarketModel(true)}
                />
          </div>
          <Card style={{ minWidth: 275,width:'100%',backgroundColor:'#E5E7ED' }}>
            <CardContent>
              {/* <Typography variant="h6">Markets</Typography> */}
              {marketOfficeData && marketOfficeData.map((market) => (
                <div
                  key={market?.marketId}
                  className="btn-cluster-grp"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '8px',
                    cursor: 'pointer',
                    gap: '8px',
                    borderRadius:'4px',
                    alignItems:"center",
                    marginBottom:"8px",
                    backgroundColor: selectedMarket?.marketId === market?.marketId ? '#1891F6' : '#FFFFFF',
                  }}
                  onClick={() => setSelectedMarket(market)}
                >
                  <Typography>{market?.marketName}</Typography>
                  <div className="grid-icon">
                    {/* <button 
                      className="goto-button" 
                      style={{backgroundColor: selectedMarket?.marketId === market?.marketId ? '#FFFFFF' : '#1891F6',color:selectedMarket?.marketId === market?.marketId ? '#1891F6' : '#FFFFFF'}} >Go To Regions</button> */}
                    {/* <div className="grid-action-item-icon-container">
                      <PersonOutlineOutlinedIcon />
                    </div> */}
                    <div className="grid-action-item-icon-container" key={"right"}>
                      <EditIcon
                        className="grid-action-item-icon"
                        onClick={() => handleEditOpen(market, 'market')}
                      />
                    </div>
                    <div className="grid-action-item-icon-container">
                      <DeleteIcon
                        className="grid-action-item-icon"
                        onClick={(event) => deleteConfirmRegion(event,market,'market')}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>
        {/* )} */}
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      {/* Add New Region, Sales Office, Market Dialog */}
      <DMModal open={showNewRegionModel} onClose={() => setShowNewRegionModel(false)}>
        <div style={modalStyle} className={classes.paper}>
          <h3 id="simple-modal-title">New Region</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <TextField
              id="outlined-basic-userName"
              label="Name*"
              variant="outlined"
              autoComplete="off"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <Grid
              item
              xs={9}
              container
              style={{ justifyContent: "center" }}
            >
              <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  // style={{float:"right"}}
                  onClick={() => {
                    setIsDisabled(true);
                    setShowNewRegionModel(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAddRegion}
                  //disabled={isDisabled}
                  // style={{marginLeft:"10px"}}
                  className="makeStyles-gradient-27"
                >
                  OK
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </DMModal> 
      {/**Add Sales Office Dailog */}
      <DMModal open={showNewSalesOfficeModel} onClose={() => setShowNewSalesOfficeModel(false)}>
        <div style={modalStyle} className={classes.paper}>
          <h3 id="simple-modal-title">{!editOffice?"New":"Edit"} Sales Office</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <TextField
              id="outlined-basic-userName"
              label="Name*"
              variant="outlined"
              autoComplete="off"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <TextField
              id="region-name-select-required-label"
              select
              label={"Currency"}
              variant="outlined"
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
              placeholder="Currency"
            >
              {dataCurrencyVal?.map((currency) => {
                return (
                  <MenuItem key={currency.currencyId} value={currency.currencyId}>
                    {currency.currencyName}
                  </MenuItem>
                );
              })}
            </TextField>
            <Grid item className="switch-grid-container">
              <AntSwitch
                checked={isCarrierOffice}
                onChange={() => setIsCarrierOffice(!isCarrierOffice)}
                name={"Status"}
              />
              <Typography style={{ fontSize: "20px" }}>
                Is a Carrier Office
              </Typography>
            </Grid>
            <Grid item className="switch-grid-container">
              <AntSwitch
                checked={isDevelopedEconomy}
                onChange={() => setIsDevelopedEconomy(!isDevelopedEconomy)}
                name={"Status"}
              />
              <Typography style={{ fontSize: "20px" }}>
                Is a Developed Economy
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}
              container
              style={{ justifyContent: "center",maxWidth:"100%" }}
            >
              <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  // style={{ float: "right" }}
                  onClick={() => {
                    setIsDisabled(true);
                    setShowNewSalesOfficeModel(false);
                    setUserName('');
                    setSelectedCurrency('');
                    setIsCarrierOffice(false);
                    setIsDevelopedEconomy(false);
                    setEditOffice(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleCreateSalesOffice}
                  //disabled={isDisabled}
                  // style={{ marginLeft: "10px" }}
                  className="makeStyles-gradient-27"
                >
                  OK
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </DMModal>
      <DMModal open={showNewMarketModel} onClose={() => setShowNewMarketModel(false)}>
        <div style={modalStyle} className={classes.paper}>
          <h3 id="simple-modal-title">Add Market</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <TextField
              id="outlined-basic-userName"
              label="Name*"
              variant="outlined"
              autoComplete="off"
              type="text"
              value={marketName}
              onChange={(e) => setMarketName(e.target.value)}
            />
            <Grid
              item
              xs={9}
              container
              style={{ justifyContent: "center" }}
            >
              <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  // style={{float:"right"}}
                  onClick={() => {
                    setIsDisabled(true);
                    setShowNewMarketModel(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAddMarket}
                  //disabled={isDisabled}
                  // style={{marginLeft:"10px"}}
                  className="makeStyles-gradient-27"
                >
                  OK
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </DMModal>            
      {/**Edit Dialog */}
      <Dialog open={openDialog} onClose={handleEditClose}>
        <DialogTitle>Edit {editingType.charAt(0).toUpperCase() + editingType.slice(1)}</DialogTitle>
        <DialogContent style={{}}>
          <TextField
            label={`${editingType.charAt(0).toUpperCase() + editingType.slice(1)} Name`}
            variant="outlined"
            fullWidth
            value={editData}
            onChange={(e) => setEditData(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose} color="primary">Cancel</Button>
          <Button className="saveBtn" onClick={() => handleEditSave(editingType)} color="primary">OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  miscState: state.misc,
  deleteState: state.model.deleteModel,
  currencyState: state.model.currency,
  createState: state.model.createNewModel,
  breadCrumbInStore: state.misc.bredCrumb
});

const mapDispatchToProps = (dispatch) => {
  return {
    getModels: async () => dispatch(modelAction.getModels()),
    deleteModel: async (requestPayload) =>
      dispatch(modelAction.deleteModel(requestPayload)),
    createNewModel: async (requestPayload) =>
      dispatch(modelAction.createNewModel(requestPayload)),
    updateModel: async (requestPayload) =>
      dispatch(modelAction.updateModel(requestPayload)),
    getRegions: async () => dispatch(modelAction.getRegions()),
    // onMoreOptionsSelected: (modelId) =>
    //   dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
    getRegionsT: async() => dispatch(modelAction.getRegionsT()),
    getSalesOffice: async(region) => dispatch(modelAction.getSalesOffice(region)),
    getMarket: async(sales) => dispatch(modelAction.getMarket(sales)),
    addNewRegion: async(regionName) => dispatch(modelAction.addNewRegion(regionName)),
    deleteAdminService: async(regionId,type) => dispatch(modelAction.deleteAdminService(regionId,type)),
    updateRegionSalesMarket: async(data,type) => dispatch(modelAction.updateRegionSalesMarket(data,type)),
    addNewMarket: async(data) => dispatch(modelAction.addNewMarket(data)),
    getCurrency: async() => dispatch(modelAction.getCurrency()),
    createNewSalesOffice: async(data) => dispatch(modelAction.createNewSalesOffice(data)),
    onModelSelected: async(modelType) => dispatch(miscAction.onModelSelected(modelType)),
    updateSalesOffice: async(data) => dispatch(modelAction.updateSalesOffice(data)),
    breadCrumbSettingAction: async(breadCrumb) => dispatch(miscAction.breadCrumbSettingAction(breadCrumb))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Models);
